import React from 'react';
import Home from './pages/Home'; // Adjust the path as needed

function App() {
  return (
    // The Home component already contains the full layout: Header, Main, Footer
    <Home />
  );
}

export default App;